import { Injectable } from '@angular/core';
import { createSelector } from '@ngrx/store';
import { MagazineSelector } from '../magazine/magazine.selectors';
import { NewspaperSelector } from '../newspaper/newspaper.selectors';

@Injectable()
export class ArticleSelector {
	constructor(private newspaperSelector: NewspaperSelector, private magazineSelector: MagazineSelector) {}

	public mediaArticle = createSelector(this.newspaperSelector.selected, this.magazineSelector.selected, (newspaper, magazine) => newspaper || magazine);
}
